"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectListChooserState = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const multi_list_chooser_state_1 = require("./multi.list.chooser.state");
class SelectListChooserState extends multi_list_chooser_state_1.MultiChooserState {
    constructor(field) {
        super(field.schema.displayName);
        this.field = field;
        this.formField = field.schema;
        this.setValue([this.field.value]);
    }
    get displayValue() {
        return this.field.hasValue() ? this.field.displayValue : null;
    }
    get groups() {
        const visibleOptions = this.getVisibleOptions();
        if (visibleOptions.length === 0) {
            return [];
        }
        return [{
                title: (0, i18n_1.Translate)(i18n_1.T.SELECT_OPTION),
                items: visibleOptions,
                selected: this.value != null ? this.value[0] : visibleOptions[0].key
            }];
    }
    setValue(value) {
        if (value == null || value.length === 0 || value[0] === core_shared_1.FormModelFieldSelectList.UNSELECTED_VALUE) {
            this._value = null;
        }
        else {
            this._value = value;
        }
    }
    selectDefaultValue() {
        const visibleOptions = this.getVisibleOptions();
        if (visibleOptions.length > 0) {
            this.setValue([visibleOptions[0].key]);
            return;
        }
        this.setValue(null);
    }
    getVisibleOptions() {
        const visibleOptions = [];
        for (const option of this.formField.options) {
            if (option.value !== core_shared_1.FormModelFieldSelectList.UNSELECTED_VALUE) {
                visibleOptions.push({ key: option.value, value: option.text, color: option.color });
            }
        }
        return visibleOptions;
    }
}
exports.SelectListChooserState = SelectListChooserState;
tslib_1.__decorate([
    mobx_1.computed
], SelectListChooserState.prototype, "displayValue", null);
tslib_1.__decorate([
    mobx_1.computed
], SelectListChooserState.prototype, "groups", null);
tslib_1.__decorate([
    mobx_1.action
], SelectListChooserState.prototype, "setValue", null);
tslib_1.__decorate([
    mobx_1.action
], SelectListChooserState.prototype, "selectDefaultValue", null);
//# sourceMappingURL=select.list.chooser.state.js.map